import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import HomePageReducer from "../views/user_views/accounts/HomePageReducer";
import VendorReducer from "../views/user_views/forms/AddDetails/Vendor/Vendor.reducer";
import UploadFilesReducer from "../views/user_views/forms/UploadFiles/UploadFileReducer";
import POSReducer from "../views/user_views/forms/POSModule/POSReducer";
import UserReducer from "../views/user_views/forms/AddUser/user.reducers";
import CouponReducer from "../views/user_views/forms/AddDetails/AddCoupons/Coupon.reducer";
import sizeReducer from "../views/user_views/forms/AddDetails/AddSize/size.reducer";
import ColourReducer from "../views/user_views/forms/AddDetails/AddColour/Colour.reducer";
import CustomerReducer from "../views/user_views/forms/AddDetails/AddCustomer/Customer.reducer";
import hallReducer from "../views/user_views/forms/AddDetails/AddHall/Hall.reducer";
import ResturantReducer from "../views/user_views/forms/AddDetails/AddResturant/Resturant.reducer";
import TableReducer from "../views/user_views/forms/AddDetails/AddTable/Table.reducer";
import DayReducer from "../views/user_views/forms/AddDetails/Day/Day.reducer";
import MasterControlReducer from "../views/user_views/forms/AddDetails/AddMasterControl/AccountsIntegrationReducer";
import ProductReducer from "../views/user_views/forms/AddDetails/AddProduct/Product.reducer";
import WarehouseReducer from "../views/user_views/forms/AddDetails/Warehouse/Warehouse.reducer";
import CategoryReducer from "../views/user_views/forms/AddDetails/categories/Catagory.reducer";
import SubCategoryReducer from "../views/user_views/forms/AddDetails/subCategory/SubCategory.reducer";
import RecipeReducer from "../views/user_views/forms/AddDetails/Recipe/Recipe.reducer";
import ReportReducer from "../views/user_views/forms/AddDetails/Reports/Report.resucer";
import RecivingReducer from "../views/user_views/forms/AddDetails/AddReciving/Receiving.reducer";
import InventoryLegderReducer from "../views/user_views/forms/AddDetails/InventoryLedger/InventoryLedger.reducer";
import BackUpReducer from "../views/user_views/forms/Settings/BackUp/BackUp.reducers";
import CreateDealReducer from "../views/user_views/forms/AddDetails/AddDeal/CreateDeal.reducer";
import IssuanceReducer from "../views/user_views/forms/AddDetails/Issuance/Issuance.reducer";
import uomReducer from "../views/user_views/forms/AddDetails/AddUOM/Uom.reducer";
import BarcodeReducer from "../views/user_views/forms/AddDetails/Barcode/Barcode.reducer";
import brandReducer from "../views/user_views/forms/AddDetails/Brand/Brand.reducer";
import PurchaseReducer from "../views/user_views/forms/AddDetails/PurchaseOrder/PurchaseOrder.reducer";
import DemandReducer from "../views/user_views/forms/AddDetails/Demand/Demand.reducer";
import IGPReducer from "../views/user_views/forms/AddDetails/Igp/IGP.reducer";
import OrderCreationReducer from "../views/user_views/forms/Production/orderCreation/OrderCreationReducer";
import ExpenseTypeReducer from "../views/user_views/forms/AddDetails/expense/Expense.reducer";
import permissionReducer from "../views/user_views/forms/AddDetails/Permissions/UserPermissions.reducer";
import DivisionReducer from "../views/user_views/forms/HRModule/division/divisionReducer";
import DepartmentReducer from "../views/user_views/forms/HRModule/department/departmentReducer";
import DesignationReducer from "../views/user_views/forms/HRModule/designation/designationReducer";
import ShiftControlReducer from "../views/user_views/forms/HRModule/shiftControl/shiftControlReducer";
import EmployeeTypeReducer from "../views/user_views/forms/HRModule/employeeType/employeeTypeReducer";
import EmployeeReducer from "../views/user_views/forms/HRModule/employee/employeeReducer";
import SalaryReducer from "../views/user_views/forms/HRModule/salary/salaryReducer";
import IncrementReducer from "../views/user_views/forms/HRModule/increment/incrementReducer";
import STReducer from "../views/user_views/forms/HRModule/ST-Advance/STRedcuer";
import LTReducer from "../views/user_views/forms/HRModule/LT-Advance/LTReducer";
import MasterControlHRReducer from "../views/user_views/forms/HRModule/masterControlHR/masterControlHRReducer";
import FineReducer from "../views/user_views/forms/HRModule/fineAndPenalty/FineAndPenaltyReducer";
import AttendanceReducer from "../views/user_views/forms/HRModule/attendance/attendanceReducer";
import ProcessReducer from "../views/user_views/forms/Production/process/ProcessReducer";
import ProductionEmployeeReducer from "../views/user_views/forms/Production/productionEmployee/ProductionEmployeeReducer";
import ArticleReducer from "../views/user_views/forms/Production/article/ArticleReducer";
import MachineReducer from "../views/user_views/forms/Production/machine/MachineReducer";
import CostControlReducer from "../views/user_views/forms/Production/costControl/CostControlReducer";
import ProductionIssuanceReducer from "../views/user_views/forms/Production/productionIssuance/ProductionIssuanceReducer";
import ProductionReceivingReducer from "../views/user_views/forms/Production/productionReceiving/ProductionReceivingReducer";
import CustomerReducerCRM from "../views/user_views/forms/CRMModule/CRMCustomer/CustomerReducerCRM";
import CRMProductReducer from "../views/user_views/forms/CRMModule/CRMProducts/CRMProductReducer";
import LevelTwoReducer from "../views/user_views/forms/AccountsModule/LevelTwo/LevelTwoReducer";
import LevelOneReducer from "../views/user_views/forms/AccountsModule/LevelOne/LevelOneReducer";
import LevelThreeReducer from "../views/user_views/forms/AccountsModule/LevelThree/LevelThreeReducer";
import LevelFourReducer from "../views/user_views/forms/AccountsModule/LevelFour/LevelFourReducer";
import VouchersReducer from "../views/user_views/forms/AccountsModule/Vouchers/VouchersReducer";
import AccountLegderReducer2 from "../views/user_views/forms/AccountsModule/Ledger/LedgerReducer";
import TrailBalanceReducer from "../views/user_views/forms/AccountsModule/TrailBalance/TrailReducer";
import InvoiceReducer from "../views/user_views/forms/AccountsModule/Invoice/InvoiceReducer";
import AccountsDashboardReducer from "../views/user_views/forms/AccountsModule/AccountsDashboard/AccountsDashboardReducer";
import TeamMemberReducer from "../views/user_views/forms/CRMModule/TeamMember/TeamMemberReducer";
import JobReducer from "../views/user_views/forms/CRMModule/Job/JobReducer";
import AreaReducer from "../views/user_views/forms/AddDetails/AddArea/areaReducer";
import ShopReducer from "../views/user_views/forms/AddDetails/AddShop/Shop.reducer";
import OrderBookingReducer from "../views/user_views/forms/AddDetails/OrderBooking/OrderBookingReducer";
import PaymentReceivingReducer from "../views/user_views/forms/AddDetails/PaymentReceiving/PaymentReceivingReducer";
import WhatsAppReducer from "../views/user_views/forms/Settings/WhatsAppSMS.js/WhatsAppRedeucer";
import ConstructionOrderReducer from "../views/user_views/forms/ConstructionModule/ConstructionOrder/ConstructionOrderReducer";
import ConstructionOrderPaymentReducer from "../views/user_views/forms/ConstructionModule/ConstructionOrderPayment/ConstructionOrderPaymentReducer";
import ExpenseReducer from "../views/user_views/forms/ConstructionModule/Expense/ExpenseReducer";
import FBRCompanyReducer from "../views/user_views/forms/FBRInvoice/FBRCompany/FBRCompanyReducer";
import FBRProductReducer from "../views/user_views/forms/FBRInvoice/FBRProduct/FBRProductReducer";
import FBRBuyerReducer from "../views/user_views/forms/FBRInvoice/FBRBuyer/FBRBuyerReducer";


const AllReducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    HomePageReducer,
    UploadFilesReducer,
    DemandReducer,
    permissionReducer,
    POSReducer,
    UserReducer,
    CouponReducer,
    sizeReducer,
    ColourReducer,
    CustomerReducer,
    IGPReducer,
    hallReducer,
    ResturantReducer,
    TableReducer,
    DayReducer,
    ReportReducer,
    MasterControlReducer,
    ProductReducer,
    WarehouseReducer,
    CategoryReducer,
    SubCategoryReducer,
    RecipeReducer,
    RecivingReducer,
    InventoryLegderReducer,
    VendorReducer,
    BackUpReducer,
    CreateDealReducer,
    IssuanceReducer,
    uomReducer,
    BarcodeReducer,
    brandReducer,
    PurchaseReducer,
    OrderCreationReducer,
    ExpenseTypeReducer,
    DivisionReducer,
    DepartmentReducer,
    DesignationReducer,
    ShiftControlReducer,
    EmployeeTypeReducer,
    EmployeeReducer,
    SalaryReducer,
    IncrementReducer,
    STReducer,
    MasterControlHRReducer,
    LTReducer,
    FineReducer,
    AttendanceReducer,
    ProcessReducer,
    ProductionEmployeeReducer,
    ArticleReducer,
    MachineReducer,
    CostControlReducer,
    ProductionIssuanceReducer,
    ProductionReceivingReducer,
    CustomerReducerCRM,
    CRMProductReducer,
    InvoiceReducer,
    LevelOneReducer,
    LevelTwoReducer,
    LevelThreeReducer,
    LevelFourReducer,
    VouchersReducer,
    AccountLegderReducer2,
    TrailBalanceReducer,
    AccountsDashboardReducer,
    TeamMemberReducer,
    JobReducer,
    AreaReducer,
    ShopReducer,
    OrderBookingReducer,
    PaymentReceivingReducer,
    WhatsAppReducer,
    ConstructionOrderReducer,
    ConstructionOrderPaymentReducer,
    ExpenseReducer,
    FBRCompanyReducer,
    FBRProductReducer,
    FBRBuyerReducer,
  });

export default AllReducers